export default {
	data() {
		return {
			bankSwitcher: 'onlineBank',
		}
	}
}
